import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=5089baa7&scoped=true"
import script from "./branches.vue?vue&type=script&lang=js"
export * from "./branches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089baa7",
  null
  
)

export default component.exports